export default __webpack_public_path__ + "static/media/icn-arrow-down.b70c8ebd.svg";